module.exports = __webpack_public_path__ + "img/logistics_eten.png";